import React from 'react';
import { format } from 'date-fns';
import { ClipboardIcon } from '@heroicons/react/24/outline';

import CopyTextWithTooltip from '@dashboard/components/CopyTextWithTooltip';
import { Badge } from '@dashboard/components/ui/badge';

const EVENTS = {
  connected: { label: 'Connected', variant: 'success' },
  disconnected: { label: 'Disconnected', variant: 'destructive' },
};

const formatDate = value => format(new Date(value), 'd MMM, yyyy, HH:mm');

export default function StripeConnectionHistory({ history = [] }) {
  if (!history.length) {
    return (
      <span className="text-gray-500 dark:text-muted-foreground">
        No connection history recorded
      </span>
    );
  }

  const entries = [...history].reverse();

  return (
    <ul className="space-y-3">
      {entries.map((entry, index) => {
        const { label, variant } = EVENTS[entry.event] ?? {
          label: entry.event,
          variant: 'secondary',
        };
        const replaced =
          entry.previousStripeAccountId && entry.previousStripeAccountId !== entry.stripeAccountId
            ? entry.previousStripeAccountId
            : null;

        return (
          <li key={`${entry.at}-${index}`} className="">
            <div className="flex items-center gap-x-2 gap-y-1">
              <CopyTextWithTooltip text={entry.stripeAccountId}>
                <div className="flex gap-x-1 items-center">
                  <span>{entry.stripeAccountId}</span>
                  <ClipboardIcon className="w-4 h-4" />
                </div>
              </CopyTextWithTooltip>
              <Badge variant={variant}>{label}</Badge>
            </div>
            <div className="text-xs text-gray-500 dark:text-muted-foreground">
              <span>{formatDate(entry.at)}</span>
              {replaced && (
                <>
                  {' · '}
                  <span>replaced {replaced}</span>
                </>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
